import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import localforage from 'localforage'
import AuditLogsController from '~/controllers/auditLogs'
import { usersStore } from '~/store/users'
import { fb_auth } from '~/services/firebase'
import type { JUser } from '~/models/users/JUser'
import { JAuditLogsAction } from '~/models/auditLogs/JAuditLogs'
import loggerHelper from '~/helpers/LoggerHelper'

const auth = getAuth()
const channel = new BroadcastChannel('logoutChannel')

export const loadUser = async (): Promise<any> => {
  const user: any = auth.currentUser
  if (user) {
    const userId: string = user?.uid ? user?.uid : ''
    return await usersStore().loadUser(userId)
  }
}

// DON'T USE CLONE DEEP, it breaks update user
export const getUserById = (idUser: string): JUser => {
  return usersStore().findUser(idUser)
}

// export const getOrg = async(userId: string) => {
//   const user = await dbHelper.getDocFromCollection(USER_COLLECTION_NAME, userId)
//   const clientId = user?.client_id
//   const client = await dbHelper.getDocFromCollection(CLIENT_COLLECTION_NAME, clientId)
//   const slug = client?.slug ?? 'default'
//   return slug
// }

export const getUserId = () => {
  const user = fb_auth.currentUser
  if (user) {
    const userId: string = user?.uid ? user?.uid : ''
    return userId
  }
  return ''
}

export const signIn = async (email: string, password: string) => {
  await signInWithEmailAndPassword(fb_auth, email, password)
  await loadUser()
  AuditLogsController.createNewAudit({ action: JAuditLogsAction.login })
}

export const logout = async () => {
  try {
    loggerHelper.logInfo(`User ${fb_auth.currentUser?.displayName} is logging out`)

    $crisp.push(['do', 'session:reset'])
    const currentUser = fb_auth.currentUser
    await AuditLogsController.createNewAudit({ action: JAuditLogsAction.logout })
    if (currentUser && currentUser?.uid === JSON.parse(await localforage.getItem('currentUser'))?.id)
      channel.postMessage('logout')

    localforage.removeItem('currentUser')
    await fb_auth.signOut()
  }
  catch (err) {
    console.error(`Error logging out ${err}`)
  }
}
